export default "__VITE_ASSET__CN9wFJcI__"